import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { getScreens, type IScreensReadParams } from 'shared/src/api';
import { useGetCommonParams } from '../../hooks';
import { useFilterListAtom } from 'shared/src/component/AtomicRenderer/ItemList/FilterList/Provider/filterList/useFilterListAtom';

export const useGetScreensInfiniteQuery = () => {
  const {
    filterListAtomValue: { screen_name, ...restFilterListAtomValue },
  } = useFilterListAtom();
  const { nextToken } = useGetCommonParams();

  const queryResult = useInfiniteQuery({
    queryKey: [
      'getScreens',
      { ...restFilterListAtomValue, nextToken, screen_name },
    ],
    queryFn: ({ pageParam }) => {
      const requestParams = {
        ...restFilterListAtomValue,
        next_token: pageParam ?? null,
        screen: screen_name,
      } as IScreensReadParams;
      return getScreens(requestParams);
    },
    enabled: nextToken !== undefined && screen_name !== undefined,
    initialPageParam: nextToken,
    getNextPageParam: lastPage => {
      return lastPage.nextToken || undefined;
    },
    select: data => {
      const components = data.pages.flatMap(page => page.components);
      const formattedData = {
        ...data.pages[data.pages.length - 1],
        components,
      };

      return formattedData;
    },
    placeholderData: keepPreviousData,
  });

  return queryResult;
};
